const FormTitle = ({ children }) => {
  return (
    <header>
      <h1>{children}</h1>
    </header>
  );
};

export default FormTitle;
